module.exports = __webpack_public_path__ + "img/vehicle-slides-with-backdrop-mazda.5d0863ef.png";